import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import bundleNetPrice, { resetBundleNetPrice } from '../../../actions/BundleNetPriceAction';
import withBundleSkuValidation from '../BundleSkuValidation/BundleSkuValidation';
import productPricingSelector, {
    isSameProductsCoupons,
    isAllItemsHaveCoupons,
} from '../../../selectors/Bundle/BundleProductPricingSelector';
import Pricing from './BundlePricing';
import { selectedProductsForBundles } from '../../../selectors/Bundle/BundleProductOptionsSelector';
import { isFpacForBundle as isFpacForBundleSelector } from '../../../selectors/Bundle/BundleCommonSelector';

let lineItems = []; // for price api to block on OOS product and for avoiding multiople price api request

/* istanbul ignore next */
export class BundlePricingWrapper extends Component {
    static propTypes = {
        getBundleSkuValidation: PropTypes.func,
        pricingDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        selectedBundleSkus: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
        bundleQuantity: PropTypes.oneOfType([PropTypes.object]),
        productDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        actions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        productOptions: PropTypes.oneOfType([PropTypes.object]),
        isSameCoupons: PropTypes.bool,
        allItemsHaveCoupons: PropTypes.bool,
        isFpacForBundle: PropTypes.bool,
        featureFlags: PropTypes.object,
    };

    static defaultProps = {
        getBundleSkuValidation: null,
        pricingDetails: {},
        productDetails: {},
        selectedBundleSkus: {},
        bundleQuantity: {},
        actions: {},
        productOptions: {},
        featureFlags: {},
        isSameCoupons: false,
        allItemsHaveCoupons: false,
        isFpacForBundle: false,
    };

    constructor(props) {
        super(props);
        this.state = {
            bundleEnabled: false,
        };
    }

    componentDidMount() {
        const bundleSkuValidationResult = this.props.getBundleSkuValidation();
        if (bundleSkuValidationResult.isEverySKUSelected) {
            this.selectedSkuDetails();
        }
        this.setState({
            bundleEnabled: true,
        });
    }

    shouldComponentUpdate(nextProps) {
        const {
            bundleQuantity,
            productDetails,
            productOptions,
            pricingDetails,
            getBundleSkuValidation,
        } = this.props;

        return (
            !isEqual(bundleQuantity, nextProps.bundleQuantity) ||
            !isEqual(productOptions, nextProps.productOptions) ||
            !isEqual(productDetails.products, nextProps.productDetails.products) ||
            !isEqual(getBundleSkuValidation, nextProps.getBundleSkuValidation) ||
            !isEqual(pricingDetails, nextProps.pricingDetails)
        );
    }

    componentDidUpdate(prevProps) {
        const { bundleQuantity, productOptions } = this.props;

        /* istanbul ignore next */
        if (
            !isEqual(bundleQuantity, prevProps.bundleQuantity) ||
            !isEqual(productOptions, prevProps.productOptions)
        ) {
            this.selectedSkuDetails();
        }
    }

    selectedSkuDetails = () => {
        const {
            productDetails,
            actions,
            bundleQuantity,
            selectedBundleSkus,
            isFpacForBundle,
            pricingDetails: { couponInfo = {} } = {},
        } = this.props;
        let skuInfo;
        /* istanbul ignore next */
        if (lineItems.length) {
            lineItems = [];
        }

        if (productDetails.products) {
            productDetails.products.map((productInfo) => {
                const quantity = bundleQuantity[productInfo.base.id];
                skuInfo = get(selectedBundleSkus, productInfo.base.id, {});

                if (quantity && skuInfo.isItemInStock) {
                    /* istanbul ignore next */
                    if (skuInfo.filteredItems && skuInfo.filteredItems.length === 1) {
                        const { id } = skuInfo.filteredItems[0];
                        const productId = id.substring(0, 7);
                        const skuId = id.slice(-4);

                        lineItems.push({
                            skuId,
                            productId,
                            quantity,
                        });
                    }
                }

                return null;
            });
        }

        /* istanbul ignore next */
        if (!lineItems.length) {
            const RESET_BUNDLE_PRICE = {};
            actions.resetBundleNetPrice(RESET_BUNDLE_PRICE);
            return;
        }
        const selectedProductsDetails = {
            coupons: couponInfo && isFpacForBundle ? [{ code: couponInfo.alphaId, id: '' }] : [],
            lineItems,
        };

        actions.bundleNetPrice(selectedProductsDetails);
    };

    render() {
        const {
            pricingDetails,
            featureFlags,
            allItemsHaveCoupons,
            isSameCoupons,
            isFpacForBundle,
            bundleQuantity,
            productDetails: { products = [] },
        } = this.props;

        const bundleQtyArr = Object.entries(bundleQuantity);
        const { bundleEnabled } = this.state;

        const bnlpProducts = products && products.map((data) => data.product);
        const lots = bnlpProducts && bnlpProducts.map((data) => data.lots[0]);
        const buyNowPayLaterEligible =
            lots && lots.filter((data) => data.buyNowPayLaterEligible === true);
        const availableItemLength = bundleQtyArr.filter((data) => data[1] > 0);
        return (
            <>
                <Pricing
                    pricingDetails={pricingDetails}
                    isSameCoupons={isSameCoupons}
                    isFpacForBundle={isFpacForBundle}
                    featureFlags={featureFlags}
                    allItemsHaveCoupons={allItemsHaveCoupons}
                    productType="bundle"
                    isNetLevelPrice
                    isBundlePage
                    isAddtoCartPricing
                    bundleEnabled={bundleEnabled}
                    buyNowPayLaterEligibleLen={buyNowPayLaterEligible.length}
                    availableItemLength={availableItemLength.length}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    pricingDetails: productPricingSelector(state).calcBundleNetPrice,
    selectedBundleSkus: selectedProductsForBundles(state),
    bundleQuantity: state.bundleQuantity,
    productDetails: state.productDetails,
    productOptions: state.productOptions,
    featureFlags: state.context.featureFlags,
    isSameCoupons: isSameProductsCoupons(state),
    allItemsHaveCoupons: isAllItemsHaveCoupons(state),
    isFpacForBundle: isFpacForBundleSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            bundleNetPrice,
            resetBundleNetPrice,
        },
        dispatch
    ),
});

export default compose(
    withBundleSkuValidation(),
    connect(mapStateToProps, mapDispatchToProps)
)(BundlePricingWrapper);
